import Confirm from 'garden/src/js/components/confirm'

export default function confirm (callback, textMessage, ...options) {
  const buttons = { textConfirmButton: 'Confirmar', textCancelButton: 'Cancelar' }
  const params = Object.assign({}, { textMessage }, buttons, ...options)

  return new Confirm(callback, params)
}
